module.exports = __webpack_public_path__ + "img/twitter-line-dark.3d5eff8.svg";